import { render, staticRenderFns } from "./NewsPreloader.vue?vue&type=template&id=4ea3b43b&scoped=true&"
var script = {}
import style0 from "./NewsPreloader.vue?vue&type=style&index=0&id=4ea3b43b&scoped=true&lang=css&"
import style1 from "./NewsPreloader.vue?vue&type=style&index=1&id=4ea3b43b&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3b43b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea3b43b')) {
      api.createRecord('4ea3b43b', component.options)
    } else {
      api.reload('4ea3b43b', component.options)
    }
    module.hot.accept("./NewsPreloader.vue?vue&type=template&id=4ea3b43b&scoped=true&", function () {
      api.rerender('4ea3b43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/NewsPreloader.vue"
export default component.exports